<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        aria-hidden="true"
        class="mb-0"
      >
        <b-alert
          variant="primary"
          show
        >
          <h4 class="alert-heading border-top">
            {{ itemDetails.title }}
          </h4>
          <div class="alert-body border-btm">
            <span>
              <strong>Description:</strong> {{ itemDetails.description }}
            </span>
          </div>
          <div class="alert-body">
            <span>
              <strong>Type:</strong> {{ itemDetails.list_type }}
            </span>
          </div>
        </b-alert>
      </b-card>
      <b-card
        no-body
        class="business-card mt-2"
      >
        <b-card-body>
          <div
            v-if="businessItems.length > 0"
          >
            <div
              v-if="itemDetails.list_type === 'case'"
              class="business-items"
            >
              <div
                v-for="(businessItem, index) in businessItems"
                :key="index"
                class="item-row"
              >
                <div
                  v-if="businessItem.userActions !== null"
                  class="business-item p-0"
                >
                  <app-collapse>
                    <app-collapse-item title="User Action Required">
                      <div class="demo-inline-spacing">
                        <template
                          v-for="(button, bindex) in businessItem.userActions.buttons"
                        >
                          <b-button
                            v-if="button.button_title !== 'Await Module'"
                            :key="bindex"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="'gradient-'+button.button_color"
                            class="mt-0"
                            style="width:10%;"
                            @click="userActionButtonClicked(businessItem.userActions.process_id, button.id, businessItem.debt_case.id, businessItem.id)"
                          >
                            {{ button.button_title }}
                          </b-button>
                        </template>
                      </div>
                    </app-collapse-item>
                  </app-collapse>
                </div>
                <div
                  v-else
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <div>
                      Case {{ businessItem.debt_case.id }} has been assigned to you.
                    </div>
                    <div
                      v-if="businessItem.debt_case.status === 0"
                      class="demo-inline-spacing "
                    >
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-primary"
                        class="mt-0"
                        @click="taskAction(businessItem.debt_case.id, businessItem.id, 1, index)"
                      >
                        Accept
                      </b-button>
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-danger"
                        class="mt-0"
                        @click="taskAction(businessItem.debt_case.id, businessItem.id, 2, index)"
                      >
                        Decline
                      </b-button>
                    </div>
                    <div
                      v-else
                      class="demo-inline-spacing item-approval-div"
                    >
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        :variant="businessItem.debt_case.status === 1 ? 'outline-primary' : 'outline-warning'"
                        class="mt-0 defaultcursor"
                      >
                        {{ businessItem.debt_case.status === 1 ? 'Case has been approved.' : 'Case has been declined.' }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="business-items"
            >
              <div
                v-for="(businessItem, index) in businessItems"
                :key="index"
                class="business-item"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    {{ itemDetails.list_type === 'debtor' ? 'Debtor' : 'Client' }} {{ businessItem.ref }} has been assigned to you.
                  </div>
                  <div
                    :class="'demo-inline-spacing item-btns-'+index"
                  >
                    <b-link
                      :to="{ name: itemDetails.list_type === 'debtor' ? 'debtor-view' : 'client-view', params: { id: businessItem.ref } }"
                      class="margin-right: 15px; font-weight-bold d-block text-nowrap mt-0"
                      target="_blank"
                    >
                      <feather-icon
                        icon="EyeIcon"
                      />
                    </b-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
          >
            <b-alert
              variant="warning"
              show
            >
              <div class="alert-body">
                There is no item added.
              </div>
            </b-alert>
          </div>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BAlert, BCard, BCardBody, BButton, BLink,
  // BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { avatarText } from '@core/utils/filter'
// import { ref/* , onUnmounted  */ } from '@vue/composition-api'
import { EventBus } from '@/event-bus'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import axios from '@axios'

// import formValidation from '@core/comp-functions/forms/form-validation'
import { required, alphaNum, email } from '@validations'

export default {
  components: {
    BOverlay,
    BAlert,
    BCard,
    BCardBody,
    BButton,
    BLink,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      selected: [],
      alertErrors: [],
      userType: JSON.parse(localStorage.getItem('userData')),
      itemDetails: [],
      loader: false,
      businessItems: [],
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(newValue) {
        console.log('Selected users changed', newValue)
      },
    },
    role: {
      handler() {
        this.getRolePermissions()
      },
    },
  },
  created() {
    this.getDetails()
  },
  methods: {
    userActionButtonClicked(processId, buttonId, caseId, taskItemId) {
      // const caseId = this.$route.params.id
      const form = new FormData()
      form.append('process_id', processId)
      form.append('button_id', buttonId)
      form.append('case_id', caseId)
      form.append('description', 'Action performed in the task list.')
      const url = '/process/case/run-button-module'
      axios.post(url, form).then(response => {
        if (response.status === 200) {
          axios.post('/task-list/mark-list-item', {
            id: taskItemId,
            list_id: Number(this.$route.params.id),
          }).then(() => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Action performed on button.',
              },
            })
            this.getDetails()
          })
        }
      })
    },
    // eslint-disable-next-line no-unused-vars
    async taskAction(id, taskId, status, index) {
      this.loader = true
      // console.log('index', index)
      await axios.post('/approve-debt-case', {
        debt_case_id: id,
        status,
        taskId,
      }).then(response => {
        if (response.status === 200) {
          // document.querySelector(`.item-approval-div-${index}`).style.display = 'block'
          // document.querySelector(`.item-btns-${index}`).style.display = 'none'
          axios.post('/task-list/mark-list-item', {
            id: taskId,
            list_id: Number(this.$route.params.id),
          }).then(() => {
            EventBus.$emit('refreshNotificationTotal')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Success',
                icon: 'CoffeeIcon',
                variant: status === 1 ? 'success' : 'danger',
                text: status === 1 ? 'Case has been approved successfully.' : 'Case has been declined successfully.',
              },
            })
            this.getDetails()
          })
            .catch(() => {
              this.$router.push('/')
            })
        }
      })
    },
    async getDetails() {
      this.loader = true
      // const id = this.$route.params.id,
      // console.log('working ')
      await axios.get(`/task-list/get-task-details?id=${this.$route.params.id}`).then(response => {
        if (response.status === 200) {
          // console.log('response ', response.data.data)
          this.loader = false
          this.itemDetails = response.data.data
          this.businessItems = response.data.data.task_list_items
          // console.log('businessItems ', this.businessItems)
        }
      })
        .catch(() => {
          this.loader = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}

.border-btm, .border-top {
  border-bottom: 1px solid #a5d3cf;
}

.item-row {
  margin-top: 10px;
}

.defaultcursor {
  cursor: default !important;
}
</style>
